import MicroModal from "micromodal";

export function setupMobileNav(ds: kendo.data.DataSource) {
  $("#mobilemenu").kendoPanelBar({
    dataSource: ds,
  });

  const $drawer = $("#drawer");

  MicroModal.init({
    disableScroll: true,
  });

  $(".drawer-trigger").click(function (e) {
    if (($drawer[0] as HTMLElement).classList.contains("is-open")) {
      MicroModal.close("drawer");
    } else {
      MicroModal.show("drawer");
    }

    e.stopPropagation();
  });
}

window["setupMobileNav"] = setupMobileNav;
